
      import SendBackward from './send-backward.vue'
      import type { App, Plugin } from 'vue'

      export const SendBackwardPlugin: Plugin = {
        install(app: App) {
          app.component('SendBackward', SendBackward)
        },
      }
      export { SendBackward }
      